// extracted by mini-css-extract-plugin
export default {"badge":"messenger-count-badge_badge__6+3W7"};